module.exports = __webpack_public_path__ + "img/sin_auto.503f7552.png";